import React, {Fragment} from 'react';
import { useSelector } from "react-redux";
import { NavLink } from 'react-router-dom';
import './SideBar.scss';

import logo from '../../assets/logo/logo_agronet.png';
import { ReactComponent as DashboardIcon} from '../../assets/icons/dashboard.svg';
import { ReactComponent as FieldsIcon} from '../../assets/icons/fields.svg';
import { ReactComponent as UserIcon} from '../../assets/icons/user.svg';
import { ReactComponent as NotificationsIcon} from '../../assets/icons/notifications.svg';
import {isCompanyAdmin, isCompanyUser, isCustomer, isDistributorAdmin, isSuperAdmin} from "../../helpers/helpers";
import ExpandableMenu from "../_common/ExpandableMenu";

const selector = state => {
    const { language } = state;
    return {
        t: language.translator,
    };
};

const SideBar = props => {
    const {responsive} = props;
    const { t } = useSelector(selector);
    return (
        <nav className='sidebar'>
            <li className='appName'>
                <img
                    src={logo}
                    alt='App Logo'
                    className='appLogo'
                />
            </li>

            <ul className='appNav'>

                <li className='appNavItem'>
                    <NavLink exact to='/'>
                        <div className='appNavItemIconHolder'>
                            <DashboardIcon className='appNavItemIcon'/>
                        </div>
                        <div className='appNavItemLabel'>
                            {t.gettext('Dashboard')}
                        </div>
                    </NavLink>
                </li>

                <ExpandableMenu menuType={'sensors'} menuTitle={t.gettext('Sensors')}>
                    <li className='appNavItem'>
                        <NavLink exact to='/sensor'>
                            <div className='appNavItemIconHolder'>
                                <div className='appNavItemIconHolder'/>
                            </div>
                            <div className='appNavItemLabel'>
                                <ul>
                                    <li style={{listStyleType: 'initial'}}>
                                        {t.gettext('Sensor List')}
                                    </li>
                                </ul>
                            </div>
                        </NavLink>
                    </li>
                    {isSuperAdmin() &&
                        <li className='appNavItem'>
                            <NavLink exact to='/sensor_groups'>
                                <div className='appNavItemIconHolder'>
                                    <div className='appNavItemIconHolder'/>
                                </div>
                                <div className='appNavItemLabel'>
                                    <ul>
                                        <li style={{listStyleType: 'initial'}}>
                                            {t.gettext('Sensor groups')}
                                        </li>
                                    </ul>
                                </div>
                            </NavLink>
                        </li>
                    }
                    <li className='appNavItem'>
                        <NavLink exact to='/sensor_validation'>
                            <div className='appNavItemIconHolder'><div className='appNavItemIconHolder'/></div>
                            <div className='appNavItemLabel'><ul><li style={{listStyleType: 'initial'}}>{t.gettext('Validation')}</li></ul></div>
                        </NavLink>
                    </li>
                    {isSuperAdmin() &&
                        <li className='appNavItem'>
                            <NavLink exact to='/temperature_map_history'>
                                <div className='appNavItemIconHolder'><div className='appNavItemIconHolder'/></div>
                                <div className='appNavItemLabel'><ul><li style={{listStyleType: 'initial'}}>{t.gettext('Temperature map history')}</li></ul></div>
                            </NavLink>
                        </li>
                    }
                </ExpandableMenu>
                {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin() || isCustomer() || isCompanyUser()) &&
                    <ExpandableMenu menuType={'reports'} menuTitle={t.gettext('Reports')}>
                        <li className='appNavItem'>
                            <NavLink exact to='/sensor_reports'>
                                <div className='appNavItemIconHolder'>
                                    <div className='appNavItemIconHolder'/>
                                </div>
                                <div className='appNavItemLabel'>
                                    <ul>
                                        <li style={{listStyleType: 'initial'}}>
                                            {t.gettext('Sensor reports')}
                                        </li>
                                    </ul>
                                </div>
                            </NavLink>
                        </li>
                        {isSuperAdmin() &&
                            <li className='appNavItem'>
                                <NavLink exact to='/sensor_group_reports'>
                                    <div className='appNavItemIconHolder'>
                                        <div className='appNavItemIconHolder'/>
                                    </div>
                                    <div className='appNavItemLabel'>
                                        <ul>
                                            <li style={{listStyleType: 'initial'}}>
                                                {t.gettext('Sensor group reports')}
                                            </li>
                                        </ul>
                                    </div>
                                </NavLink>
                            </li>
                        }
                        <li className='appNavItem'>
                            <NavLink exact to='/weather_reports'>
                                <div className='appNavItemIconHolder'>
                                    <div className='appNavItemIconHolder'/>
                                </div>
                                <div className='appNavItemLabel'>
                                    <ul>
                                        <li style={{listStyleType: 'initial'}}>
                                            {t.gettext('Weather Data Reports')}
                                        </li>
                                    </ul>
                                </div>
                            </NavLink>
                        </li>
                        {isSuperAdmin() &&
                            <li className='appNavItem'>
                                <NavLink exact to='/db_performance'>
                                    <div className='appNavItemIconHolder'><div className='appNavItemIconHolder'/></div>
                                    <div className='appNavItemLabel'><ul><li style={{listStyleType: 'initial'}}>{t.gettext('Database performance')}</li></ul></div>
                                </NavLink>
                            </li>
                        }
                    </ExpandableMenu>
                }
                <ExpandableMenu menuType={'stations'} menuTitle={t.gettext('Stations')}>
                    {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin() || isCustomer()) &&
                        <li className='appNavItem'>
                            <NavLink exact to='/weather_stations'>
                                <div className='appNavItemIconHolder'>
                                    <div className='appNavItemIconHolder'>
                                        {/*<span className="material-icons material-icons-outlined appNavItemIcon">*/}
                                        {/*    sensors*/}
                                        {/*</span>*/}
                                    </div>
                                </div>
                                <div className='appNavItemLabel'>
                                    <ul>
                                        <li style={{listStyleType: 'initial'}}>
                                            {t.gettext('Weather Stations')}
                                        </li>
                                    </ul>
                                </div>
                            </NavLink>
                        </li>
                    }
                    {isSuperAdmin() &&
                        <li className='appNavItem'>
                            <NavLink exact to='/station_status'>
                                <div className='appNavItemIconHolder'>
                                    <div className='appNavItemIconHolder'>
                                        {/*<span className="material-icons material-icons-outlined appNavItemIcon">*/}
                                        {/*    sensors*/}
                                        {/*</span>*/}
                                    </div>
                                </div>
                                <div className='appNavItemLabel'>
                                    <ul>
                                        <li style={{listStyleType: 'initial'}}>
                                            {t.gettext('Station status')}
                                        </li>
                                    </ul>
                                </div>
                            </NavLink>
                        </li>
                    }
                    {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin() || isCustomer()) &&
                        <li className='appNavItem'>
                            <NavLink exact to='/drain_stations'>
                                <div className='appNavItemIconHolder'>
                                    <div className='appNavItemIconHolder'>
                                        {/*<span className="material-icons material-icons-outlined appNavItemIcon">*/}
                                        {/*    sensors*/}
                                        {/*</span>*/}
                                    </div>
                                </div>
                                <div className='appNavItemLabel'>
                                    <ul>
                                        <li style={{listStyleType: 'initial'}}>
                                            {t.gettext('Drain Stations')}
                                        </li>
                                    </ul>
                                </div>
                            </NavLink>
                        </li>
                    }
                    {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin() || isCustomer()) &&
                        <li className='appNavItem'>
                            <NavLink exact to='/gate_switchers'>
                                <div className='appNavItemIconHolder'>
                                    <div className='appNavItemIconHolder'>
                                        {/*<span className="material-icons material-icons-outlined appNavItemIcon">*/}
                                        {/*    sensors*/}
                                        {/*</span>*/}
                                    </div>
                                </div>
                                <div className='appNavItemLabel'>
                                    <ul>
                                        <li style={{listStyleType: 'initial'}}>
                                            {t.gettext('Gate Switchers')}
                                        </li>
                                    </ul>
                                </div>
                            </NavLink>
                        </li>
                    }
                </ExpandableMenu>
                <ExpandableMenu menuType={'sensorSettings'} menuTitle={t.gettext('Sensor Settings')}>
                    <li className='appNavItem appNavItem--expanded'>
                        <NavLink exact to='/alert_rules'>
                            <div className='appNavItemIconHolder'>
                                <div className='appNavItemIconHolder'>
                                    {/*<span className="material-icons material-icons-outlined appNavItemIcon">*/}
                                    {/*    sensors*/}
                                    {/*</span>*/}
                                </div>
                            </div>
                            <div className='appNavItemLabel'>
                                <ul>
                                    <li style={{listStyleType: 'initial'}}>
                                        {t.gettext('Alert Rules')}
                                    </li>
                                </ul>

                            </div>
                        </NavLink>
                    </li>
                    <li className='appNavItem'>
                        <NavLink exact to='/calibration_values'>
                            <div className='appNavItemIconHolder'>
                                <div className='appNavItemIconHolder'>
                                    {/*<span className="material-icons material-icons-outlined appNavItemIcon">*/}
                                    {/*    sensors*/}
                                    {/*</span>*/}
                                </div>
                            </div>
                            <div className='appNavItemLabel'>
                                <ul>
                                    <li style={{listStyleType: 'initial'}}>
                                        {t.gettext('Calibration Values')}
                                    </li>
                                </ul>
                            </div>
                        </NavLink>
                    </li>
                    <li className='appNavItem'>
                        <NavLink exact to='/warm_hours'>
                            <div className='appNavItemIconHolder'>
                                <div className='appNavItemIconHolder'>
                                    {/*<span className="material-icons material-icons-outlined appNavItemIcon">*/}
                                    {/*    sensors*/}
                                    {/*</span>*/}
                                </div>
                            </div>
                            <div className='appNavItemLabel'>
                                <ul>
                                    <li style={{listStyleType: 'initial'}}>
                                     {t.gettext('Rising Hours')}
                                    </li>
                                </ul>
                            </div>
                        </NavLink>
                    </li>
                    <li className='appNavItem'>
                        <NavLink exact to='/cold_hours'>
                            <div className='appNavItemIconHolder'>
                            <div className='appNavItemIconHolder'>
                                    {/*<span className="material-icons material-icons-outlined appNavItemIcon">*/}
                                    {/*    sensors*/}
                                    {/*</span>*/}
                                </div>
                            </div>
                            <div className='appNavItemLabel'>
                                <ul>
                                    <li style={{listStyleType: 'initial'}}>
                                        {t.gettext('Cold Hours')}
                                    </li>
                                </ul>
                            </div>
                        </NavLink>
                    </li>
                </ExpandableMenu>
                {(!process.env.REACT_APP_CLIENT_VERSION || process.env.REACT_APP_CLIENT_VERSION === 'no') && (
                    <Fragment>
                        {isSuperAdmin() &&
                            <li className='appNavItem'>
                                <NavLink exact to='/community_sensors'>
                                    <div className='appNavItemIconHolder'>
                                        <div className='appNavItemIconHolder'>
                                    <span className="material-icons material-icons-outlined appNavItemIcon">
                                        sensors
                                    </span>
                                        </div>
                                    </div>
                                    <div className='appNavItemLabel'>
                                        {t.gettext('Community Sensors')}
                                    </div>
                                </NavLink>
                            </li>
                        }
                        <li className='appNavItem'>
                            <NavLink exact to='/field_groups'>
                                <div className='appNavItemIconHolder'>
                                    <div className='appNavItemIconHolder'>
                                        <FieldsIcon className='appNavItemIcon'/>
                                    </div>
                                </div>
                                <div className='appNavItemLabel'>
                                    {t.gettext('Field Groups')}
                                </div>
                            </NavLink>
                        </li>
                        <li className='appNavItem'>
                            <NavLink exact to='/user_details'>
                                <div className='appNavItemIconHolder'>
                                    <div className='appNavItemIconHolder'>
                                        <UserIcon className='appNavItemIcon'/>
                                    </div>
                                </div>
                                <div className='appNavItemLabel'>
                                    {t.gettext('User Details')}
                                </div>
                            </NavLink>
                        </li>

                        {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin()) &&
                            <ExpandableMenu menuType={'users'} menuTitle={t.gettext('Users')}>
                                {(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin()) &&
                                    <li className='appNavItem'>
                                        <NavLink exact to='/manage_users'>
                                            <div className='appNavItemIconHolder'>
                                                <div className='appNavItemIconHolder'>
                                                </div>
                                            </div>
                                            <div className='appNavItemLabel'>
                                                <ul>
                                                    <li style={{listStyleType: 'initial'}}>
                                                        {isSuperAdmin() ? t.gettext('Admin Users') : t.gettext('Manage Users')}
                                                    </li>
                                                </ul>
                                            </div>
                                        </NavLink>
                                    </li>
                                }
                                {isSuperAdmin() &&
                                    <li className='appNavItem'>
                                        <NavLink exact to='/manage_all_users'>
                                            <div className='appNavItemIconHolder'>
                                                <div className='appNavItemIconHolder'>
                                                </div>
                                            </div>
                                            <div className='appNavItemLabel'>
                                                <ul>
                                                    <li style={{listStyleType: 'initial'}}>
                                                        {t.gettext('Manage All Users')}
                                                    </li>
                                                </ul>
                                            </div>
                                        </NavLink>
                                    </li>
                                }
                                {(isSuperAdmin() || isDistributorAdmin()) &&
                                    <li className='appNavItem'>
                                        <NavLink exact to='/users_access_table'>
                                            <div className='appNavItemIconHolder'>
                                                <div className='appNavItemIconHolder'>
                                                </div>
                                            </div>
                                            <div className='appNavItemLabel'>
                                                <ul>
                                                    <li style={{listStyleType: 'initial'}}>
                                                        {t.gettext('Users Access Table')}
                                                    </li>
                                                </ul>
                                            </div>
                                        </NavLink>
                                    </li>
                                }
                                {isSuperAdmin() &&
                                    <li className='appNavItem'>
                                        <NavLink exact to='/direct_notifications'>
                                            <div className='appNavItemIconHolder'>
                                                <div className='appNavItemIconHolder'>
                                                </div>
                                            </div>
                                            <div className='appNavItemLabel'>
                                                <ul>
                                                    <li style={{listStyleType: 'initial'}}>
                                                        {t.gettext('Direct notifications')}
                                                    </li>
                                                </ul>
                                            </div>
                                        </NavLink>
                                    </li>
                                }
                                {isSuperAdmin() &&
                                    <li className='appNavItem'>
                                        <NavLink to='/user_messages'>
                                            <div className='appNavItemIconHolder'>
                                                <div className='appNavItemIconHolder'>
                                                </div>
                                            </div>
                                            <div className='appNavItemLabel'>
                                                <ul>
                                                    <li style={{listStyleType: 'initial'}}>
                                                        {t.gettext('In-app messages')}
                                                    </li>
                                                </ul>
                                            </div>
                                        </NavLink>
                                    </li>
                                }
                            </ExpandableMenu>
                        }
                        <li className='appNavItem'>
                            <NavLink exact to='/notifications'>
                                <div className='appNavItemIconHolder'>
                                    <div className='appNavItemIconHolder'>
                                        <NotificationsIcon className='appNavItemIcon'/>
                                    </div>
                                </div>
                                <div className='appNavItemLabel'>
                                    {t.gettext('Notifications')}
                                </div>
                            </NavLink>
                        </li>

                        {isSuperAdmin() &&
                            <li className='appNavItem'>
                                <NavLink exact to='/companies'>
                                    <div className='appNavItemIconHolder'>
                                        <div className='appNavItemIconHolder'>
                                    <span className="material-icons appNavItemIcon">
                                        business
                                    </span>
                                        </div>
                                    </div>
                                    <div className='appNavItemLabel'>
                                        {t.gettext('Companies')}
                                    </div>
                                </NavLink>
                            </li>
                        }
                        {(isSuperAdmin() || isCompanyAdmin()) &&
                            <ExpandableMenu menuType={'qrCodes'} menuTitle={t.gettext('QR generators')}>
                                <li className='appNavItem'>
                                    <NavLink exact to='/qr_code_generator'>
                                        <div className='appNavItemIconHolder'>
                                            <div className='appNavItemIconHolder'>
                                    {/*<span className="material-icons appNavItemIcon">*/}
                                    {/*    qr_code_2*/}
                                    {/*</span>*/}
                                            </div>
                                        </div>
                                        <div className='appNavItemLabel'>
                                            <ul>
                                                <li style={{listStyleType: 'initial'}}>
                                                    {t.gettext('QR Code Generator')}
                                                </li>
                                            </ul>
                                        </div>
                                    </NavLink>
                                </li>
                                <li className='appNavItem'>
                                    <NavLink exact to='/qr_code_generator_multiple'>
                                    <div className='appNavItemIconHolder'>
                                            <div className='appNavItemIconHolder'>
                                    {/*<span className="material-icons appNavItemIcon">*/}
                                    {/*    qr_code_2*/}
                                    {/*</span>*/}
                                            </div>
                                        </div>
                                        <div className='appNavItemLabel'>
                                            <ul>
                                                <li style={{listStyleType: 'initial'}}>
                                                    {t.gettext('QR Code Generator Multiple')}
                                                </li>
                                            </ul>
                                        </div>
                                    </NavLink>
                                </li>
                                <li className='appNavItem'>
                                    <NavLink exact to='/qr_code_generator_black'>
                                        <div className='appNavItemIconHolder'>
                                            <div className='appNavItemIconHolder'>
                                    {/*<span className="material-icons appNavItemIcon">*/}
                                    {/*    qr_code_2*/}
                                    {/*</span>*/}
                                            </div>
                                        </div>
                                        <div className='appNavItemLabel'>
                                            <ul>
                                                <li style={{listStyleType: 'initial'}}>
                                                    {t.gettext('QR Code Generator White')}
                                                </li>
                                            </ul>
                                        </div>
                                    </NavLink>
                                </li>
                                <li className='appNavItem'>
                                    <NavLink exact to='/qr_code_generator_no_background'>
                                        <div className='appNavItemIconHolder'>
                                            <div className='appNavItemIconHolder'>
                                    {/*<span className="material-icons appNavItemIcon">*/}
                                    {/*    qr_code_2*/}
                                    {/*</span>*/}
                                            </div>
                                        </div>
                                        <div className='appNavItemLabel'>
                                            <ul>
                                                <li style={{listStyleType: 'initial'}}>
                                                    {t.gettext('QR Code Generator No Background')}
                                                </li>
                                            </ul>
                                        </div>
                                    </NavLink>
                                </li>
                            </ExpandableMenu>
                        }
                    </Fragment>
                )}

            </ul>
        </nav>
    );
};

export default SideBar;
